/**
 * 仓库 表单验证规则
 * @author zjs
 * @time 2017-12-11
 */
export default {
    data () {
        return {
            formRules: {
                'warehouse_code' : [{ required: true, trigger: 'blur' }],
                'name': [{ required: true, trigger: 'blur' }]
            }
        }
    }
}